<template>
    <accordion-list v-model="accordionSelected" class="text-left">
        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-1">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    How do I check in guests who didn’t RSVP?
                </div>
            </template>

            <template #content>
                <p>You can check in guests using the RSVPify desktop app, any modern web browser, or the RSVPify iOS and Android mobile apps.</p>
                <p class="italic">Note: Badge printing is only supported via the desktop app.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-2">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can I check in guests using a QR code?
                </div>
            </template>

            <template #content>
                <p>Yes! Guests can be scanned in using their unique QR code. You can also check them in manually by name, email, or confirmation number.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-3">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    What if someone didn’t RSVP or preregister?
                </div>
            </template>

            <template #content>
                <p>No problem — you can add walk-ins directly from the check-in interface with just a few clicks.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-4">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can multiple team members check in guests at the same time?
                </div>
            </template>

            <template #content>
                <p>Yes! RSVPify supports simultaneous check-in across multiple devices, so your whole team can check in guests in real time from different entry points.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-5">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Do guests need to bring anything to check in?
                </div>
            </template>

            <template #content>
                <p>Guests can present their RSVP confirmation email with QR code, but it’s not required. You can always look them up manually.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-6">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can I print name badges during check-in?
                </div>
            </template>

            <template #content>
                <p>Yes. Badge printing is available for supported printers and can be triggered automatically or manually using the desktop app.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-7">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    What printers work with RSVPify’s badge printing?
                </div>
            </template>

            <template #content>
                <p>We recommend the <span
                    class="font-semibold"
                >Brother QL‑820NWB</span> label printer for best results with sticker badge printing. Other QL-series models may work, but support may vary.
                </p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-8">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can I test the check-in system before my event?
                </div>
            </template>

            <template #content>
                <p>Absolutely. You can preview the check-in interface and even check in test guests ahead of time. All check-in data can be reset before your event.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-9">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can I export check-in data?
                </div>
            </template>

            <template #content>
                <p>Yes. You can download check-in logs and activity reports (in CSV format) from your dashboard’s reporting section.</p>
            </template>
        </accordion-list-item>

        <accordion-list-item class="mb-2 p-2 border-b" item-id="question-10">
            <template #header="{ active }">
                <div :class="{ 'mb-4': active }">
                    Can I track check-ins across different sessions or days?
                </div>
            </template>

            <template #content>
                <p>Yes. RSVPify supports multi-session check-in, allowing you to track attendance across multiple dates, sessions, or venues.</p>
            </template>
        </accordion-list-item>
    </accordion-list>
</template>

<script>
export default {
    data () {
        return {
            accordionSelected: ''
        };
    }
};
</script>
